import { orderService } from '@/services';

export const orderModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    order:{
      data: null,
      error: null,
    },
    newOrder:{
      data: null,
      error: null,
    },
    updateOrder:{
      data: null,
      error: null,
    },
    ordersExcel:{
      data: null,
      error: null,
    },
    orderTracking:{
      data: null,
      error: null,
      isLoading: false,
    },
    orderProgress:{
      data: null,
      error: null,
    },
    orderResource:{
      data: {
        images: null,
        documents: null,
      },
      error: null
    },
    onHoldStatus:{
      data: null,
      status: null
    },
    cancelEntity:{
      data: null,
      status: null
    },
    recoverEntity:{
      data: null,
      status: null
    },
  }),
  mutations: {
    loadResource(state, orderId) {
      orderService.getResources(orderId)
        .then((res) => {
          state.orderResource.data = { ...res }
        })
        .catch((error) => {
          state.orderResource.data.images = null
          state.orderResource.data.documents = null
          state.orderResource.error = error
        });      
    },
    appendImage(state, entity) {
      state.orderResource.data.images.push(entity)
    },
    appendDocument(state, entity) {
      state.orderResource.data.documents.push(entity)
    },
    removeImage(state, entity) {
      const currentImages = [ ...state.orderResource.data.images ]
      state.orderResource.data.images = currentImages.filter(image => image['name'] != entity['name'])
    },
    removeDocument(state, entity) {
      const currentDocuments = [ ...state.orderResource.data.documents ]
      state.orderResource.data.documents = [ ...currentDocuments.filter(document => document['name'] != entity['name']) ]
    },
    downloadResource(state,request){
      orderService.downloadResource(request.orderId, request.fileName)
      .then((excel) => {
        state.orderResource.data = excel
        state.orderResource.error = null
      })
      .catch((error) => {
        state.orderResource.data = null
        state.orderResource.error = error
      });
    },
    resetResources(state) {
      state.orderResource.data.images = null
      state.orderResource.data.documents = null
      state.orderResource.error = null     
    },
    load(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      orderService.getOrdersList(request.pagination,request.filters)
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });    
    },
    newOrder(state, body) {
      orderService.newOrder(body)
        .then((res) => { state.newOrder.data = res })
        .catch((error) => { state.newOrder.data = null; state.newOrder.error = error });
    },
    updateOrder(state, body) {
      orderService.updateOrder(body)
        .then((res) => { state.updateOrder.data = res })
        .catch((error) => { state.updateOrder.data = null; state.updateOrder.error = error });
    },
    getById(state, orderId) {
      orderService.getOrder(orderId)
        .then((res) => {
          state.order.data = res
        })
        .catch((error) => {
          state.order.data = null
          state.order.error = error
        });      
    },
    ordersExcel(state, request){
      orderService.getOrdersAsExcel(request.filters, request.language)
      .then((excel) => {
        state.ordersExcel.data = excel
        state.ordersExcel.error = null
      })
      .catch((error) => {
        state.ordersExcel.data = null
        state.ordersExcel.error = error
      });
    },
    getTracking(state, orderId) {
      // Cleared up-front: the store is shared between visits, so keeping the
      // previous order's tracking would paint it until this request resolves.
      state.orderTracking.data = null
      state.orderTracking.error = null
      state.orderTracking.isLoading = true
      orderService.getTracking(orderId)
        .then((res) => {
          state.orderTracking.data = res
        })
        .catch((error) => {
          state.orderTracking.data = null
          state.orderTracking.error = error
        })
        .finally(() => {
          state.orderTracking.isLoading = false
        });
    },
    getProgress(state, orderId) {
      // Cleared up-front, like the tracking: the store is shared between
      // visits and would paint the previous order's progress meanwhile.
      state.orderProgress.data = null
      state.orderProgress.error = null
      orderService.getProgress(orderId)
        .then((res) => {
          state.orderProgress.data = res
        })
        .catch((error) => {
          state.orderProgress.data = null
          state.orderProgress.error = error
        });
    },
    onHoldStatus(state, payload){
      orderService.onHoldStatus({ on_hold: payload.on_hold }, payload.entityId)
      .then((res) => {
        state.onHoldStatus.data = { ...res }
        state.onHoldStatus.status = {
          onHoldStatus: true
        }
      })
      .catch((error) => {
        state.onHoldStatus.data = null
        state.onHoldStatus.status = {
          ...error
        }
      }); 
    },
    cancel(state, entityId){
      orderService.cancel(entityId)
      .then((res) => {
        state.cancelEntity.data = { ...res }
        state.cancelEntity.status = {
          canceled: true,
        }
      })
      .catch((error) => {
        state.cancelEntity.data = null
        state.cancelEntity.status = {
          ...error
        }
      }); 
    },
    recover(state, entityId){
      orderService.recover(entityId)
      .then((res) => {
        state.recoverEntity.data = { ...res }
        state.recoverEntity.status = {
          recovered: true,
        }
      })
      .catch((error) => {
        state.recoverEntity.data = null
        state.recoverEntity.status = {
          ...error
        }
      }); 
    },
  },
  actions: {
    // Resolves with the PDF blob (the axios interceptor already unwraps
    // response.data); the caller saves it and handles the errors.
    async downloadDeliveryNote(_, orderId) {
      return orderService.getDeliveryNote(orderId);
    },
  }
}
